export const attributesLabels = {
  'cira_legal_type': {
    label: 'Legal Type',
  },
  'cira_whois_display': {
    label: 'Whois Display',
  },
  'cira_language': {
    label: 'Language',
  },
  'cira_agreement_version': {
    label: 'Agreement Version',
  },
  'cira_agreement_value': {
    label: 'I agree to the CIRA\'s Registrant Agreement at https://cira.ca/registrant-agreement',
  },
  'us_nexus': {
    label: 'Nexus',
  },
  'global_cc_us': {
    label: 'Country',
  },
  'us_purpose': {
    label: 'Purpose'
  },
}

export const checkboxAttributes = [
  'cira_agreement_value',
]
